module.exports = __webpack_public_path__ + "img/SpectroPicSketch.546bc729.png";